import {findAll, onReady} from "../../../../modules/vegas/js/util";
import * as clipboard from "clipboard-polyfill";
import VGToast from "../../../../modules/vegas/js/toast";

function initClipboard() {
	[...findAll('[data-action=copy]')].forEach((element) => {
		element.addEventListener('click', function (event) {
			event.preventDefault();

			let text = element.dataset.text || null;
			if (text) {
				clipboard.writeText(text);

				VGToast.init({
					autohide: true,
					theme: 'dark',
					text: {
						header: '',
						body: 'Скопировано',
					}
				});
			}
		});
	});
}

onReady(initClipboard);
typeof onTurboRender !== 'undefined' && onTurboRender(initClipboard);

export default initClipboard;
